<template>
  <div class="page-basic">
    <div class="page-contentB">
      <a-layout>
        <div class="page-bHder">
          <a-layout-header>
            <div class="page-tabB">
              <a-tabs :activeKey="tabKey" @change="callbackBasic">
                <a-tab-pane
                  :tab="$tc('lang.UserCenter.General_Information')"
                  key="1"
                ></a-tab-pane>
                <a-tab-pane
                  :tab="$tc('lang.UserCenter.Security_Level')"
                  key="2"
                ></a-tab-pane>
                <a-tab-pane
                  :tab="$tc('lang.UserCenter.Company_Profile')"
                  key="3"
                ></a-tab-pane>
              </a-tabs>
            </div>
          </a-layout-header>
        </div>
        <div class="page-coBasic">
          <a-layout-content>
            <div class="page-basic-form">
              <div class="page-bas-form-all">
                <div class="page-basic-formItem">
                  <span class="page-basic-emeil"
                    >{{ $tc('lang.UserCenter.E_mail') }}：</span
                  >
                  <span
                    class="page-bs-e"
                    v-if="
                      userInfoMap.personEmail !== null ||
                        userInfoMap.personEmail !== ''
                    "
                    >{{ userInfoMap.personEmail }}</span
                  >
                  <span
                    class="page-bs-e"
                    v-if="
                      userInfoMap.personEmail === null ||
                        userInfoMap.personEmail === ''
                    "
                    >{{ $tc('lang.UserCenter.Unverified_Email') }}</span
                  >
                  <div class="page-bs-bangding">
                    <a-button
                      type="primary"
                      @click="
                        () => {
                          this.visible = true;
                        }
                      "
                    >
                      {{ $tc('lang.UserCenter.Fix_Now') }}
                    </a-button>
                  </div>
                </div>
                <div class="page-basic-formItem">
                  <span class="page-basic-pwd">
                    {{ $tc('lang.UserCenter.Password') }}：
                  </span>
                  <span
                    class="page-bs-x"
                    v-if="
                      userInfoMap.personPassword !== null ||
                        userInfoMap.personPassword !== ''
                    "
                    >**********</span
                  >
                  <span
                    class="page-bs-x"
                    v-if="
                      userInfoMap.personPassword === null ||
                        userInfoMap.personPassword === ''
                    "
                    >{{ $tc('lang.UserCenter.Please_set_your_password') }}</span
                  >
                  <div class="page-bs-buUp">
                    <a-button
                      type="primary"
                      @click="
                        () => {
                          this.visible1 = true;
                        }
                      "
                    >
                      {{ $tc('lang.UserCenter.update') }}
                    </a-button>
                  </div>
                </div>
              </div>
            </div>
          </a-layout-content>
        </div>
      </a-layout>
    </div>
    <!-- 绑定邮箱弹窗 -->
    <a-modal
      :title="$tc('lang.UserCenter.Fix_Now')"
      :width="400"
      v-model="visible"
      :destroyOnClose="true"
      @ok="handleOk"
    >
      <a-form
        :form="form"
        @submit="handleSubmit"
        style="width: 70%;margin: 0 auto"
      >
        <a-form-item>
          <a-input
            :placeholder="$tc('lang.UserCenter.Please_enter_your_mailbox')"
            v-decorator="[
              'personEmail',
              {
                rules: [
                  {
                    required: true,
                    message: $tc(
                      'lang.UserCenter.Please_enter_your_mailbox_address',
                    ),
                  },
                ],
              },
            ]"
          >
            <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input-group compact>
            <a-input
              style="width: 65%"
              :placeholder="
                $tc('lang.UserCenter.Please_enter_the_verification_code')
              "
              v-decorator="[
                'numberEm',
                {
                  rules: [
                    {
                      required: true,
                      message: $tc(
                        'lang.UserCenter.Please_enter_the_verification_code',
                      ),
                    },
                  ],
                },
              ]"
            >
              <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
            </a-input>
            <a-button
              style="font-size: 12px;width: 35%"
              :disabled="
                code == $tc('lang.UserCenter.Get_the_authentication_code')
                  ? false
                  : true
              "
              @click="getCode"
              >{{ code }}</a-button
            >
          </a-input-group>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button
          key="back"
          @click="
            () => {
              this.visible = false;
            }
          "
          >{{ $tc('lang.UserCenter.cancel') }}</a-button
        >
        <a-button key="submit" type="primary" @click="handleSubmit">
          {{ $tc('lang.UserCenter.Immediate_binding') }}
        </a-button>
      </template>
    </a-modal>
    <!-- 修改密码 -->
    <a-modal
      :title="$tc('lang.UserCenter.Modify_login_password')"
      :width="400"
      v-model="visible1"
      :destroyOnClose="true"
      @ok="handleOk1"
    >
      <a-form
        :form="form1"
        @submit="handleSubmit1"
        style="width: 70%;margin: 0 auto"
      >
        <a-form-item>
          <a-input
            v-if="
              userInfoMap.personPassword !== null ||
                userInfoMap.personPassword !== ''
            "
            :placeholder="
              $tc('lang.UserCenter.Please_enter_the_original_password')
            "
            type="password"
            v-decorator="[
              'originalPassword',
              {
                rules: [
                  {
                    required: true,
                    message: $tc('lang.UserCenter.Check_text'),
                  },
                  { validator: $checking.validatePassword },
                ],
              },
            ]"
          >
            <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            :placeholder="$tc('lang.UserCenter.Check_New_password')"
            type="password"
            v-decorator="[
              'passOne',
              {
                rules: [
                  {
                    required: true,
                    message: $tc('lang.UserCenter.Check_text'),
                  },
                  { validator: $checking.validatePassword },
                ],
              },
            ]"
          >
            <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            :placeholder="$tc('lang.UserCenter.Check_New_password')"
            type="password"
            v-decorator="[
              'passTow',
              {
                rules: [
                  {
                    required: true,
                    message: $tc('lang.UserCenter.Check_New_password'),
                  },
                ],
              },
            ]"
          >
            <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button
          key="back"
          @click="
            () => {
              this.visibleLogin = false;
            }
          "
          >{{ $tc('lang.UserCenter.cancel') }}</a-button
        >
        <a-button key="submit" type="primary" @click="handleSubmit1">
          {{ $tc('lang.UserCenter.confirm_update') }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'basic',
  data() {
    return {
      tabKey: '1',
      formLayout: 'horizontal',
      visible: false,
      form: this.$form.createForm(this),
      visible1: false,
      form1: this.$form.createForm(this),
      code: this.$tc('lang.UserCenter.Get_the_authentication_code'),
      //
      // email: '',
    };
  },
  // 数据状态处理全局
  computed: {
    // 全部用户数据
    userInfoMap: {
      get() {
        return this.$store.state.user.userInfoMap;
      },
      set(value) {
        this.$store.commit('user/save', {
          userInfoMap: value,
        });
      },
    },
    emaliNum: {
      get() {
        return this.$store.state.user.emaliNum;
      },
      set(value) {
        this.$store.commit('user/save', {
          emaliNum: value,
        });
      },
    },
  },
  created() {
    this.$store.dispatch('user/userBasicData');
    console.log('========info=====', this.userInfoMap);
    this.handleData();
  },
  methods: {
    /*基本信息,安全等级,企业资料:路由切换跳转路径*/
    callbackBasic(key) {
      console.log(key);
      if (key === '1') {
        this.$router.push('/basic');
      }
      if (key === '2') {
        this.$router.push('/safeGrade');
      }
      if (key === '3') {
        this.$router.push('/enterprise');
      }
    },
    // showModal() {
    //   this.visible = true;
    // },
    handleData() {
      this.$store.dispatch('user/userBasicData');
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    // 邮箱
    handleSubmit(e) {
      console.log(e);
      event.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          const emaliNu = this.emaliNum.toString();
          if (emaliNu === values.numberEm) {
            this.$store.dispatch('user/updatePersonMassage', values);
            this.visible = false;
            this.handleData();
            // this.$router.go(0);
          } else {
            this.$message.error('验证码不一致，请重新输入！');
          }
        }
      });
    },
    handleOk1(e) {
      console.log(e);
      this.visible1 = false;
    },
    // 密码验证
    handleSubmit1(e) {
      e.preventDefault();
      this.form1.validateFields((err, values) => {
        if (!err) {
          if (values !== {}) {
            if (values.passOne !== values.passTow) {
              this.$message.error('两个密码不一致，请重新设置！！！');
              this.form1.resetFields();
            } else {
              const data = {
                originalPassword: values.originalPassword,
                passOne: values.passOne,
                passTow: values.passTow,
                type: 9,
              };
              this.$store.dispatch('user/passwordLoginUpdate', data);
              this.form1.resetFields();
              this.visible1 = false;
            }
          }
        }
      });
    },
    // 验证码获取
    getCode() {
      const emailData = this.form.getFieldValue('personEmail');
      if (emailData !== undefined) {
        let time = 60;
        this.code = `${time}s`;
        let _this = this;
        let setTime = setInterval(function() {
          time--;
          _this.code = `${time}s`;
          if (time == 0) {
            _this.code = '获取验证码';
            clearInterval(setTime);
          }
        }, 1000);
        this.$store.dispatch('user/sendMail', emailData);
      } else {
        this.$message.error('请输入邮箱地址');
      }
    },
  },
};
</script>

<style lang="less">
.page-basic {
  .page-contentB {
    border-left: 1px solid #f0f2f5;
    border-right: 1px solid #f0f2f5;
    border-bottom: 1px solid #f0f2f5;
    border-radius: 10px;
    margin-top: 3%;
    .ant-layout {
      height: calc(100vh - 209px);
      background-color: #fff;
    }
    .page-bHder {
      .ant-layout-header {
        padding: 0 25px;
        background-color: #fff;
        height: 44px;
      }
    }
    .page-tabB {
      .ant-tabs-nav .ant-tabs-tab-active {
        background-color: #e9eef3;
      }
      .ant-tabs-nav {
        float: left;
      }
    }
    .page-coBasic {
      overflow-y: auto;
      background-color: #ffffff;
      width: 89%;
      .page-basic-form {
        border-left: 3px solid #f0f2f5;
        border-right: 2px solid #f0f2f5;
        border-bottom: 2px solid #b1b1b1;
        border-radius: 10px;
        margin: 22px;
        height: 314px;
        .page-bas-form-all {
          padding-top: 80px;
          padding-left: 190px;
          .page-basic-formItem {
            display: flex;
            .page-basic-emeil {
              font-size: 20px;
            }
            .page-bs-e {
              font-size: 16px;
              padding-left: 50px;
            }
            .page-basic-pwd {
              font-size: 20px;
              padding-top: 50px;
            }
            .page-bs-x {
              font-size: 16px;
              padding-top: 52px;
              padding-left: 50px;
            }
            .page-bs-buUp {
              padding-top: 45px;
              padding-left: 110px;
            }
            .page-bs-bangding {
              padding-left: 50px;
            }
          }
        }
      }
    }
  }
}
</style>
